import React, { useState, useEffect } from 'react'
import { IProps } from './index'
import { Swiper, SwiperSlide } from 'swiper/react'
import { ImageOrAutoplayVideo } from '../ImageOrAutoplayVideo'
import SwiperCore, { Controller } from 'swiper/core'
import { Text } from '../Text'

SwiperCore.use([Controller])

export const SupportSpotlightCarousel: React.FC<IProps> = ({ slides, isVisible }) => {
  const [firstSwiper, setFirstSwiper] = useState<SwiperCore>()
  const [secondSwiper, setSecondSwiper] = useState<SwiperCore>()

  useEffect(() => {
    firstSwiper?.update()
    secondSwiper?.update()
  }, [firstSwiper, secondSwiper])

  const videoShouldPlay = typeof isVisible === 'boolean' ? (isVisible ? 'play' : 'stop') : 'play'

  return (
    <>
      <div className="swiper-lottie">
        <Swiper onSwiper={setFirstSwiper} spaceBetween={24} controller={{ control: secondSwiper }}>
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <ImageOrAutoplayVideo
                video={slide.video}
                imageRef={slide.image}
                forcedAnimationState={videoShouldPlay}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="swiper-info">
        <Swiper
          onSwiper={setSecondSwiper}
          controller={{ control: firstSwiper }}
          centeredSlides
          slidesPerView="auto"
          spaceBetween={24}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <Text brand="default" size="body-bold">
                {slide.title}
              </Text>
              <div className="info-swiper__description"> {slide.description} </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <style jsx>{`
        .swiper-lottie {
          margin-bottom: 30px;
        }

        :global(.swiper-lottie .swiper-slide) {
          max-width: 100%;
          border-radius: 25px;
        }

        :global(.swiper-info .swiper-slide) {
          max-width: 85%;
          border-radius: 11px;
          background-color: white;
          padding: 23px 29px;
          height: auto;
        }

        :global(.info-swiper__description) {
          margin-top: 5px;
        }
      `}</style>
    </>
  )
}
